import { render, staticRenderFns } from "./PerformedWorkDetails.vue?vue&type=template&id=d020301c&scoped=true&"
import script from "./PerformedWorkDetails.vue?vue&type=script&lang=ts&"
export * from "./PerformedWorkDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PerformedWorkDetails.vue?vue&type=style&index=0&id=d020301c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d020301c",
  null
  
)

/* custom blocks */
import block0 from "./PerformedWorkDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports